<template>
  <div
    v-on:drop.prevent
    v-bind:class="fileClassList"
  >
    <span class="file-drops__label">{{ title }}</span>
    <button
      class="file-drops"
      type="button"
      v-bind:class="$attrs.invalid"
      v-on:click="onInputClick"
      v-on:dragover.prevent
      v-on:drop="dropFile"
    >
      <div
        class="file-drops__row"
        v-if="value"
        title="Скачать файл">
        <span class="file-drops__file-name">{{ value.name }}</span>
        <div class="file-drops__buttons">
          <button
            v-if="withViewButton"
            class="file-drops__button-view"
            type="button"
            title="Просмотреть файл в PDF формате"
            v-on:click.stop="viewFile"
          />
          <button
            class="file-drops__button-delete"
            type="button"
            title="Удалить файл"
            v-on:click.stop="removeFile"
          />
        </div>
      </div>
      <span class="file-drops__text" v-else title="Загрузить файл">Перетащите файл или <i>кликните</i></span>
    </button>
    <p
      class="file-drops__violation"
      role="alert"
      v-for="violationText in violations"
      v-bind:key="violationText"
    >{{ violationText }}</p>
  </div>
</template>
<script>
/**
 * @description Т=Вид файла по умоланию.
 * @type {string}
 */
const DEFAULT_VIEW = 'text';

/**
 * @description Название события скачивания файла.
 * @type {string}
 */
const NAME_EVENT_DOWNLOAD = 'download-file';

/**
 * @description Название события просмотра файла.
 * @type {string}
 */
const NAME_EVENT_VIEW = 'view-file';

/**
 * @description Название события обновления файла.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Компонент выбора файла.
 * @type {any}
 */
export default {
  data() {
    return {
      /**
       * @description Поле файла.
       */
      fileInput: {},
    };
  },
  computed: {
    /**
     * @description Классы родительского элемента.
     * @type {function(Vue): string[]}
     */
    fileClassList: ({ view }) => [
      `file-add_${view}`,
    ],
  },
  methods: {
    dropFile(ev) {
      ev.preventDefault();
      if (ev.dataTransfer.files.length > 0) {
        this.setFile(ev.dataTransfer.files[0]);
      }
    },
    removeFile() {
      this.$emit(NAME_EVENT_INPUT, null);
    },
    viewFile() {
      this.$emit(NAME_EVENT_VIEW, null);
    },
    downloadFile() {
      this.$emit(NAME_EVENT_DOWNLOAD, this.value);
    },
    setFile(file) {
      this.$emit(NAME_EVENT_INPUT, file);
    },
    onInputClick() {
      if (this.value) {
        this.downloadFile();
      } else {
        this.fileInput.click();
      }
    },
  },
  mounted() {
    this.fileInput = document.createElement('input');
    this.fileInput.type = 'file';
    this.fileInput.required = this.required;
    this.fileInput.accept = this.accept;
    this.fileInput.onchange = (event) => {
      const file = event.target.files[0];
      this.setFile(file);
    };
  },
  destroyed() {
    this.fileInput.remove();
  },
  props: {
    /**
     * @description С кнопкой просмотра.
     * @type Boolean
     */
    withViewButton: { type: Boolean, required: false, default: () => false },
    /**
     * @description Список разрешенных форматов файлов.
     * @type {string}
     */
    accept: { type: String, default: '' },
    /**
     * @description Поле обязательно для заполнения.
     * @type {boolean}
     */
    required: Boolean,
    /**
     * @description Заголовок.
     * @type {string}
     */
    title: { type: String, default: '' },
    /**
     * @description Значение.
     * @type {File|any}
     */
    value: { type: [Object, File], default: null },
    /**
     * @description Нарушения ограничений.
     * @type {any[]}
     */
    violations: { type: Array, required: true },
    /**
     * @description Тип дизайна файла.
     * @type {string}
     */
    view: {
      default: DEFAULT_VIEW,
      type: String,
      validator: (input) => [DEFAULT_VIEW, 'icon'].indexOf(input) !== -1,
    },
  },
  name: 'InputFile',
};
</script>
<style lang="scss">
.file-add {
 &_icon {
   .file-drops {
     border: none;
     height: inherit;
     padding: 0;
     &:before {
       content: '';
       background-image: url("@/assets/img/add-file-grey.svg");
       background-repeat: no-repeat;
       background-position: center;
       background-size: contain;
       width: 12px;
       height: 22px;
       margin: 0 10px 0 0;
     }
     &:hover::before {
       background-image: url("@/assets/img/add-file-blue.svg");
     }
     &__text {
       display: none;
     }
   }
 }
}
.file-drops {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #c2cfe0;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 16px;
  height: 40px;
  padding: 0 10px;
  text-align: left;
  width: 100%;
  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 15px;
    width: 100%;
  }
  &__file-name {
    font-size: 14px;
  }
  &__buttons {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
  &__button-view,
  &__button-delete {
    mask-repeat: no-repeat;
    mask-position: 50%;
    background-color: #192A3E;
    transition: all 0.3s ease 0s;
    &:hover {
      background-color:var(--action-color);
    }
  }
  &__button-view {
    width: 25px;
    height: 25px;
    mask-image: url("@/assets/img/eye-open-black.svg");
    mask-size: 22px 22px;
  }
  &__button-delete {
    width: 25px;
    height: 25px;
    mask-image: url("@/assets/img/cross/cross-black.svg");
    mask-size: 18px 18px;
  }
  &__label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--unfocus-color);
  }
  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    font-weight: 400;
    padding: .125rem;
    line-height: 14px;
  }
}

@media screen and (max-width: 480px) {
  .file-drops {
    &__file-name {
      font-size: 13px;
      line-height: normal;
    }
  }
}
</style>
